import template from './professional-logo.html';
import './professional-logo.global.css';

const SOCIAL_LINKS = [
  {
    name: 'Facebook',
    icon: 'facebook',
    property: 'facebook_url',
  },
  {
    name: 'Twitter',
    icon: 'twitter',
    property: 'twitter_url',
  },
  {
    name: 'LinkedIn',
    icon: 'linkedin',
    property: 'linkedin_url',
  },
  {
    name: 'Website',
    icon: 'home',
    property: 'website',
  },
];

const getSocialLink = (property, entity) =>
  entity.social ? entity.social[property] : null;

class ProfessionalLogoController {
  $onChanges(changes) {
    const { entity } = changes;

    if (entity && entity.currentValue) {
      this.socialLinks = SOCIAL_LINKS.map(link => ({
        url: getSocialLink(link.property, this.entity),
        ...link,
      })).filter(link => !!link.url);
    }
  }

  get name() {
    return this.entity.name;
  }

  get description() {
    return this.entity.team_name || this.entity.title;
  }

  get logoId() {
    return this.entity.logo_id;
  }
}

export const ProfessionalLogoComponent = {
  controller: ProfessionalLogoController,
  bindings: {
    entity: '<',
  },
  template,
};
